module.exports = __webpack_public_path__ + "static/media/sati_logo.33f902ac.png";